import { render, staticRenderFns } from "./CallSidebar.vue?vue&type=template&id=c40a538e&scoped=true&"
import script from "./CallSidebar.vue?vue&type=script&lang=js&"
export * from "./CallSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CallSidebar.vue?vue&type=style&index=0&id=c40a538e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40a538e",
  null
  
)

export default component.exports